import React from 'react';
import T from 'prop-types';
// utils
import getPromptsNotes from '../utils/getPromptsNotes';
// redux
import { connect } from 'react-redux';
import { setActiveNote } from '../../../redux/reducers/journals';
import { openModal } from '../../../redux/reducers/modal';
// components
import Button from '../../../components/Button/Button';
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './NoteViewer.mod.css';
import classnames from 'classnames/bind';
import moment from 'moment';

let cx = classnames.bind(styles);

const getNoteData = ({
  activeNote,
  myJournals,
  journalPrompts,
  journalPromptsFilter
}) => {
  if (!activeNote || !activeNote.id) {
    return null;
  }
  if (activeNote.type === 'myJournal') {
    return myJournals.find(note => note.id === activeNote.id);
  }
  if (activeNote.type === 'journalPrompt') {
    const promptsNotes = getPromptsNotes(journalPrompts);
    let foundedNote = null;
    Object.keys(promptsNotes).forEach(module => {
      const note = promptsNotes[module].find(
        note =>
          note.id === activeNote.id &&
          note.title
            .toLowerCase()
            .indexOf(journalPromptsFilter.toLowerCase()) >= 0
      );
      if (note) {
        foundedNote = note;
      }
    });
    return foundedNote;
  }
};

const NoteViewer = ({
  journals,
  openModal,
  className,
  userColor,
  noteViewerRef
}) => {
  const note = getNoteData(journals);
  const { title, content, type, created_at } = note || {};
  const editableNote = type !== 'journalPrompt';
  return (
    <div
      ref={noteViewerRef}
      className={cx('container', className, {
        hidden: !note
      })}
    >
      <div className={cx('title')}>
        <h3>{title}</h3>
        <span className={cx('date')}>
          {created_at && moment(created_at).format('DD/MM/YYYY ')}
          <span className={cx('time')}>
            {created_at && moment(created_at).format('h:mm')}
          </span>
        </span>
      </div>

      <pre className={cx('content')}>{content}</pre>
      {editableNote && (
        <div className={cx('buttons-section')}>
          <Button
            onClick={() => openModal('EDIT_NOTE', { note, userColor })}
            className={cx('button', 'edit-button')}
            plain
          >
            <Icon type="pen" color="black" className={cx('button-icon')} />
            <span className={cx('button-text')}>Edit</span>
          </Button>
          <Button
            onClick={() => openModal('DELETE_NOTE', { note, userColor })}
            className={cx('button', 'delete-button')}
            plain
          >
            <Icon type="delete" color="red" className={cx('button-icon')} />
            <span className={cx('button-text')}>Delete</span>
          </Button>
        </div>
      )}
    </div>
  );
};

NoteViewer.propTypes = {
  className: T.string,
  note: T.shape({
    title: T.string.isRequired,
    content: T.string.isRequired,
    id: T.number.isRequired
  })
};

export default connect(
  state => ({
    journals: state.journals,
    userColor: state.auth.user.profile_color || '#33C370'
  }),
  { setActiveNote, openModal }
)(NoteViewer);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/NoteViewer.jsx